"use strict";

var _taggedTemplateLiteral = require("/opt/build/repo/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var gsap_1 = require("gsap");
/**
 * NewsTicker is a wrapper component to create an infinite scrolling effect.
 * @version 0.0.1
 * @author Adam Gee
 */


var Wrapper = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  overflow-x: hidden;\n  position: relative;\n"])));
var Inner = styled_components_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding: 20px 0;\n  position: relative;\n  display: inline-flex;\n"])));
var Set = styled_components_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-flex;\n"])));
var Item = styled_components_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 0 10px;\n"])));

var NewsTicker = function NewsTicker(props) {
  var speed = props.speed,
      children = props.children;
  var set = (0, react_1.useRef)(null);
  var set2 = (0, react_1.useRef)(null);
  var myTween = (0, react_1.useRef)(null);
  var myTween2 = (0, react_1.useRef)(null);
  (0, react_1.useEffect)(function () {
    executeAnimations();
    return function () {
      myTween.current.kill();
      myTween2.current.kill();
    };
  }, []);

  var onMouseEnter = function onMouseEnter() {
    myTween.current.paused(true);
    myTween2.current.paused(true);
  };

  var onMouseLeave = function onMouseLeave() {
    myTween.current.paused(false);
    myTween2.current.paused(false);
  };

  var executeAnimations = function executeAnimations() {
    myTween.current = gsap_1.gsap.to(set.current, {
      duration: speed,
      x: "-100%",
      y: 0,
      ease: "linear",
      repeat: -1
    });
    myTween2.current = gsap_1.gsap.to(set2.current, {
      duration: speed,
      x: "-100%",
      y: 0,
      ease: "linear",
      repeat: -1
    });
  };

  var createNewsItemSet = function createNewsItemSet(children, ref) {
    var items = react_1.default.Children.map(children, function (child, i) {
      return react_1.default.createElement(Item, null, child);
    });
    return ref === 0 ? react_1.default.createElement(Set, {
      ref: set
    }, items) : react_1.default.createElement(Set, {
      ref: set2
    }, items);
  };

  return react_1.default.createElement(Wrapper, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, react_1.default.createElement(Inner, null, createNewsItemSet(children, 0), createNewsItemSet(children, 1)));
};

exports.default = NewsTicker;